<template>
    <div id="app">
      <router-view
        class="container"
        keep-alive
        transition
        transition-mode="out-in"
        >
      </router-view>
    </div>
</template>

<script>
  import style from './assets/base.css'

  module.exports = {
    data: function () {
      return {
        type: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?1d9d526c